<template>
  <div   class="media_con"  >
    <video
      :src="video_url4"
      controls
      poster="../../static/other/jianjie.jpg"
      width='582'
     
    >
  </video>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {
    
  },
  data() {
    return {
      hit:false,
      video_url4:
        "https://obs-db-guarantee.obs.myhuaweicloud.com/insurance/yanshi/%E5%AE%89%E8%B4%A3%E9%99%A9/vvvv.mp4",
      video_switch: false,
      
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    play(){
      this.video_switch = true
    },
  },
};
</script>

<style scoped >
.media_con {
  width: 582px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  /* position: relative; */
}

.video_con {
  /* position: absolute; */
  /* z-index: 1; */
  width: 582px;
}
.play-reload {
  width: 582px;
  height: 327.38px;
}

.play-icon {
  width: 72px;
  position: absolute;
  top: 133.5px;
  left:257px;
 
  cursor: pointer;
  z-index: 3;
}
</style>
